<app-header [user]="user()" />

<div class="www-cit">
  <app-city-top [bannerUrl]="bannerUrl()" [cityName]="cityName()" [dates]="dates()" />
  <app-city-intro id="cityContent" [intro]="intro()" />
  <app-city-plan [plan]="plan()" [img]="planImg()" />
  <app-city-rules [photos]="photos()" />
  <app-city-check-rest [showCity]="showCity()" />
  <!-- <app-pillar-intro [intro]="introText()" /> -->
  <!-- @if (tiles().length) {
    <app-pillar-tiles [tiles]="tiles()" />
  }
  @if (slides().length) {
    <app-pillar-slider [slides]="slides()" />
  } -->
  <!-- <app-pillar-contact-bar />
  <app-home-pillars />
  <app-newsletter-section /> -->
</div>
